<template>
<div class="chapter">
<div class="inner_page">
<p class="blockquote"><a id="page_xi"></a><em>The witch that came (the withered hag)<br/>To wash the steps with pail and rag<br/>Was once the beauty Abishag,</em></p>
<p class="blockquote"><em>The picture pride of Hollywood.<br/>Too many fall from great and good<br/>For you to doubt the likelihood.</em></p>
<p class="blockquote"><em>Die early and avoid the fate.<br/>Or if predestined to die late,<br/>Make up your mind to die in state.</em></p>
<p class="blockquote"><em>Make the whole stock exchange your own!<br/>If need be occupy a throne,<br/>Where nobody can call</em> you <em>crone.</em></p>
<p class="blockquote"><em>Some have relied on what they knew,<br/>Others on being simply true.<br/>What worked for them might work for you.</em></p>
<p class="blockquote"><em>No memory of having starred<br/>Atones for later disregard<br/>Or keeps the end from being hard.</em></p>
<p class="blockquote"><em>Better to go down dignified<br/>With boughten friendship at your side<br/>Than none at all. Provide, provide</em>!</p>
<p class="att1">—<em>Robert Frost,</em></p>
<p class="att2">“<em>Provide, Provide”</em></p>
<p class="blockquote"><a id="page_xii"></a><em>Not you, lean quarterlies and swarthy periodicals with your studious incursions toward the pomposity of ants, nor you, experimental theatre in which Emotive Fruition is wedding Poetic Insight perpetually, nor you, promenading Grand Opera, obvious as an ear (though you are close to my heart), but you, Motion Picture Industry it’s you I love</em>!</p>
<p class="blockquote"><em>In times of crisis, we must all decide again and again whom we love.</em></p>
<p class="att1">—<em>Frank O’Hara,</em></p>
<p class="att3">“<em>To the Film Industry in Crisis”</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm07_fm.vue?a6211472